import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-watermark',
  templateUrl: './watermark.component.html',
  styleUrls: ['./watermark.component.scss']
})
export class WatermarkComponent implements OnInit {

  text = environment.watermark;
  mode = environment.watermarkMode;
  opacity = environment.watermarkOpacity;
  size = environment.watermarkSize;
  gap = environment.watermarkGap;

  constructor() { }

  ngOnInit(): void {
  }

}
